import React from "react";
import {connect} from 'react-redux';
import _ from "lodash";
import store from "store/index";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from '@material-ui/core/LinearProgress';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

import "assets/scss/custom/react-select.css";
import AsyncSelect from 'react-select/lib/Async';
import ReactSelect from 'react-select';

import {
    ibsFetchFilter,
    ibsFetchAll,
    ibFilter,
    ibsFetch,
    ibRemove
} from 'actions/ibs'

import {
    ibAccountRuleFilter,
    ibAccountRuleFetch,
    ibAccountRuleSave,
    ibAccountRuleEditSave,
    setIbAccountRuleProfile,
    setIbAccountRuleIb
} from 'actions/ibAccountRules'

import {
    profilesFetchIbs,
    profilesFetchAllFilter,
} from 'actions/profiles'

import {danger, success} from 'actions/notification'
//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";

let platforms = {
    ANY : {value : 'ANY', label : 'Any'},
    MT4 : {value : 'MT4', label : 'MT4'},
    MT5 : {value : 'MT5', label : 'MT5'}
}

let tradingAccountTypes = {
    ANY            : {value : 'ANY', label : 'Any'},
    VARIABLE       : {value : 'VARIABLE', label : 'Variable'},
    FIXED          : {value : 'FIXED', label : 'Fixed'},
    RAW_COMMISSION : {value : 'RAW_COMMISSION', label : 'Raw_Commission'},
    SILVER         : {value : 'SILVER', label : 'Silver'},
    GOLD           : {value : 'GOLD', label : 'Gold'},
    ALL_SHARE      : {value : 'ALL_SHARE', label : 'All Share'}
}

let leverages = {
    ANY            : {value : 'ANY', label : 'Any'},
    LEVERAGE_500_1 : {value : 'LEVERAGE_500_1', label : '500:1'},
    LEVERAGE_400_1 : {value : 'LEVERAGE_400_1', label : '400:1'},
    LEVERAGE_200_1 : {value : 'LEVERAGE_200_1', label : '200:1'},
    LEVERAGE_100_1 : {value : 'LEVERAGE_100_1', label : '100:1'},
    LEVERAGE_50_1  : {value : 'LEVERAGE_50_1', label : '50:1'},
    LEVERAGE_1_1   : {value : 'LEVERAGE_1_1', label : '1:1'}
}

let accountCurrencies = {
    ANY : {value : 'ANY', label : 'Any'},
    USD : {value : 'USD', label : 'USD'},
    EUR : {value : 'EUR', label : 'EUR'},
    GBP : {value : 'GBP', label : 'GBP'}
}

const customStyles = {
    option      : (provided, state) => ({
        ...provided,
        textAlign : 'left',
    }),
    /*control: () => ({
     // none of react-select's styles are passed to <Control />
     width: 250,
     borderBottom: '1px solid silver',
   }),*/
    singleValue : (provided, state) => {
        const opacity    = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return {...provided, opacity, transition};
    }
}

class Form extends React.Component {
    state = {
        ibNameSelected         : {"value" : "0", "label" : "Select IB"},
        selectedPlatformOption : {"value" : "0", "label" : "Select Platform"},
        ibOptions              : [{value : '', label : 'All Ibs'}],
        form                   : {
            ibAccountRuleId : 0,
            ibId            : 0,
            externalIbId    : null,
            /*platform: platform[0],*/
            externalRuleId  : null,
            accountGroup    : '',
            accountPlatform : Object.keys(platforms)[0],
            accountType     : Object.keys(tradingAccountTypes)[0],
            accountLeverage : Object.keys(leverages)[0],
            accountCurrency : Object.keys(accountCurrencies)[0]
        }
    }

    componentWillMount() {
        let configVars = store.getState().config;

        if (configVars['application']) {

            if (configVars['application'] != 'kenya') {

                leverages = _.omit(leverages, ['LEVERAGE_1_1', 'LEVERAGE_50_1'])
                tradingAccountTypes = _.omit(tradingAccountTypes, ['ALL_SHARE', 'GOLD', 'SILVER'])


            }

            if (configVars['application'] === 'kenya') {

                leverages           = _.omit(leverages, ['LEVERAGE_300_1', 'LEVERAGE_500_1'])
                accountCurrencies   = _.omit(accountCurrencies, ['ANY', 'EUR', 'GBP'])
                platforms           = _.omit(platforms, ['MT4', 'ANY'])
                tradingAccountTypes = _.omit(tradingAccountTypes, ['VARIABLE', 'FIXED', 'RAW_COMMISSION'])

            }
        }
    }

    componentDidMount() {

        if (this.props.match.params.id) {

            this.props.fetch(this.props.match.params.id)
                .then(ibAccountRuleResponse => {

                    this.setState({
                        ...this.state,
                        /*ibNameSelected: {"value":e.ibId, "label":"Select IB22"},*/
                        form : {
                            ...ibAccountRuleResponse,
                            externalIbId   : null,
                            externalRuleId : null,
                        }
                    });

                    this.props.profilesFetchAll('', false)
                        .then((r) => {

                            let selectedIndex = _.findIndex(r.content, {profileId : ibAccountRuleResponse.profileId})

                            let options = r.content.map((i) => {
                                return {value : i.profileId, label : `${i.name} (${i.profileId})`}
                            })

                            if (selectedIndex > 0) {

                                this.setState({
                                    ...this.state,
                                    profileNameSelected : {value : this.state.form.profileId, label : options[selectedIndex].label}
                                });
                            }

                        });

                    if (ibAccountRuleResponse.profileId > 0) {
                        this.props.profilesFetchIbs(ibAccountRuleResponse.profileId, false).then((r) => {

                            if (r) {

                                let parentIndex = _.findIndex(r, {ib : {ibId : 1}})

                                let options = r.map((i) => {
                                    return {value : i.ib.ibId, label : `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}
                                })

                                if (options.length > 1) {
                                    options.splice(parentIndex, 1);
                                }

                                let selectedIndex = _.findIndex(options, {value : ibAccountRuleResponse.ibId})

                                //this.setState({...this.state, ibOptions: options,ibNameSelected: {value:options[selectedIndex].value, label:options[selectedIndex].label}});
                                if (selectedIndex >= 0) {
                                    this.setState({...this.state, ibOptions : options, ibNameSelected : {value : options[selectedIndex].value, label : options[selectedIndex].label}});
                                } else
                                    if ((selectedIndex < 0) && (ibAccountRuleResponse.ibId > 0)) {

                                        this.props.ibsFetchFilter().then((r) => {

                                            let options       = r.content.map((i) => {
                                                return {value : i.ibId, label : `${i.firstName} ${i.lastName} (${i.ibId})`}
                                            })
                                            let selectedIndex = _.findIndex(options, {value : ibAccountRuleResponse.ibId})
                                            this.setState({...this.state, ibOptions : options, ibNameSelected : {value : options[selectedIndex].value, label : options[selectedIndex].label}});

                                        });

                                    } else {

                                        this.setState({...this.state, ibOptions : options});
                                    }

                            }

                        });

                    } else
                        if ((!ibAccountRuleResponse.profileId > 0) && (ibAccountRuleResponse.ibId > 0)) {

                            this.props.ibsFetchFilter().then((r) => {

                                let options       = r.content.map((i) => {
                                    return {value : i.ibId, label : `${i.firstName} ${i.lastName} (${i.ibId})`}
                                })
                                let selectedIndex = _.findIndex(options, {value : ibAccountRuleResponse.ibId})
                                this.setState({...this.state, ibOptions : options, ibNameSelected : {value : options[selectedIndex].value, label : options[selectedIndex].label}});

                            });

                        }

                });

        } else {

            this.props.ibsFetchFilter('', false).then(response => {
            });
        }

        this.props.filter({size : 1000000, sort : {nameLowerCase : 'asc'}})

    }

    /*
    * onChange select options
    */
    selectProfileChange = ({value, label}) => {

        this.setState({...this.state, profileNameSelected : {value, label}, ibNameSelected : {value : '', label : 'Ibs'}})
        this.props.setIbAccountRuleProfile({profileId : value, profileName : label})


        this.setState({
            ...this.state,
            profileNameSelected : {value, label}, ibNameSelected : {value : '', label : 'Ibs'},
            form                : {
                ...this.state.form,
                profileId : value
            }
        })

        if (value > 0) {

            this.props.profilesFetchIbs(value, false).then((r) => {
                    if (r) {

                        var parentIndex = _.findIndex(r, {ib : {ibId : 1}})
                        let options     = r.map((i) => {
                            return {value : i.ib.ibId, label : `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}
                        })
                        
                        if (options.length > 1) {
                            let e = {value : options[1].value, label : options[1].label}
                            this.selectIbChange(e)
                            options.splice(parentIndex, 1);
                            this.setState({...this.state, ibOptions : options, ibNameSelected : {value : options[0].value, label : options[0].label}});
                        }


                    }
                }
            );

        }

    }

    /*
    * filter by name text
    */
    selectProfileHandleInputChange = (newValue) => {

        this.setState({...this.state, profileName : newValue})
        //this.setState({...this.state,profileId: newValue.profileId});
        return newValue;

    }

    /*
    * load select options
    */
    selectProfileLoadOptions = (inputValue, callback) => {

        //this.props.filter({size: 1000000,sort:{nameLowerCase: 'asc'}})
        return this.props.profilesFetchAll(inputValue, false)
            .then((r) => {
                    const allOption = {value : '', label : 'All Profiles'}
                    const options   = r.content.map((i) => {
                        return {value : i.profileId, label : `${i.name} (${i.profileId})`}
                    })
                    return [allOption].concat(options)
                }
            );
    }

    /*
    * onChange select options
    */
    selectIbChange = ({value, label}) => {

        let {selectedProfileId} = this.props.ibAccountRules;

        this.props.setIbAccountRuleIb({ibId : value, ibName : label})

        this.setState({
            ...this.state,
            ibNameSelected : {value, label},
            form           : {
                ...this.state.form,
                ibId : value
            }
        })


    }

    /*
    * filter by name text
    */
    selectIbHandleInputChange = (newValue) => {
        this.setState({...this.state, ibAccountRuleName : newValue})
        return newValue;
    }

    /*
    * load select options
    */
    selectIbLoadOptions = (inputValue, callback) => {
        let {selectedProfileId} = this.props.ibAccountRules;

        if (selectedProfileId) {

            return this.props.profilesFetchIbs(selectedProfileId, false)
                .then((r) => {
                        const allOption = {value : '', label : 'All Ibs'}
                        const options   = r.map((i) => {
                            return {value : i.ib.ibId, label : `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}
                        })
                        return [allOption].concat(options)
                    }
                );

        } else
            if (inputValue) {

                return this.props.profilesFetchIbs(inputValue, false)
                    .then((r) => {
                            const allOption = {value : '', label : 'All Ibs'}
                            const options   = r.map((i) => {
                                return {value : i.ib.ibId, label : `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}
                            })
                            //this.setState({...this.state, ibOptions: [allOption].concat(options)});
                            return [allOption].concat(options)
                        }
                    );

            } else {

                return {};

            }

    }

    //Submit form
    submit(e) {

//     if (e.preventDefault)
        e.preventDefault();
        let data = {...this.state.form}

        let item = {}
        for (var property in data) {
            if (data.hasOwnProperty(property) && !item[property]) {


                if (data[property] === 'ANY') {
                    data[property] = null;
                }
                item[property] = data[property]

            }
        }
        data = item;

        if (this.props.match.params.id) {

            this.props.edit(data).then(e => {

                this.props.success(this.props.match.params.id + ' ' + 'Edited !', 4);
                this.props.history.goBack()

            }).catch(e => {

                this.props.danger(e + '', 4);

            });

        } else {

            this.props.save(data).then(e => {

                this.props.success(e.ibAccountRuleId + ' ' + 'Added !', 4);
                this.props.history.goBack()

            }).catch(e => {

                this.props.danger(e + '', 4);

            });
        }


    }

    //OnChange action for all inputs and selects
    change(event, name) {

        this.setState({
            ...this.state,
            form : {
                ...this.state.form,
                [name] : event.target.value
            }
        })
    }

    render() {
        const {classes, isFetching, ibs}          = this.props;
        const {selectedPlatformOption, ibOptions} = this.state;


        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={8}>
                    <Card>
                        <CardBody>

                            {//Show progress onFetch
                                (isFetching)
                                    ? <LinearProgress/>
                                    : <form onSubmit={this
                                        .submit
                                        .bind(this)}>
                                        <GridContainer justify="center">
                                            {/*Header Information*/}
                                            <GridItem xs={12} sm={12}>
                                                <h4 className={classes.infoText}>
                                                    {this.props.match.params.id ? 'Edit' : 'Add'} IB Account Rule {this.props.match.params.id ? this.props.match.params.id : ''}
                                                </h4>
                                            </GridItem>
                                            {/*Right 2 inputs*/}

                                            {/* Select crPerType */}

                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                >

                                                    <TextField
                                                        id="accountGroup"
                                                        name="accountGroup"
                                                        label="Account Group"
                                                        type="text"
                                                        required={true}
                                                        onChange={(event) => this.change(event, "accountGroup")}
                                                        value={this.state.form.accountGroup}
                                                        //defaultValue={registrationDate}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink : true,
                                                        }}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}><br/>
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <InputLabel htmlFor="profileId" className={classes.selectLabel}>
                                                    Select Profile
                                                </InputLabel>
                                                <AsyncSelect
                                                    styles={customStyles}
                                                    loadOptions={this.selectProfileLoadOptions}
                                                    defaultOptions
                                                    onInputChange={(e) => this.selectProfileHandleInputChange(e)}
                                                    backspaceRemoves={true}
                                                    onChange={(e) => this.selectProfileChange(e)}
                                                    value={this.state.profileNameSelected || ''}
                                                    placeholder="Search Profiles..."
                                                    inputProps={{
                                                        id          : "profileId",
                                                        placeholder : "Select IB"
                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}>

                                                <div className="" style={{marginTop : '20px'}}>
                                                    <InputLabel htmlFor="ibId" className={classes.selectLabel}>
                                                        Select IB
                                                    </InputLabel>
                                                    {(ibOptions.length) &&
                                                    <ReactSelect
                                                        styles={customStyles}
                                                        options={ibOptions}
                                                        onChange={(e) => this.selectIbChange(e)}
                                                        value={this.state.ibNameSelected || ''}
                                                        placeholder="Search Ibs..."
                                                        inputProps={{
                                                            id          : "ibId",
                                                            placeholder : "Select IB"
                                                        }}
                                                    />
                                                    }
                                                </div>

                                            </GridItem>

                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                >
                                                    <InputLabel htmlFor="accountPlatform" className={classes.selectLabel}>
                                                        Select Platform
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.form.accountPlatform  || 'ANY'}
                                                        MenuProps={{
                                                            className : classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select : classes.select
                                                        }}
                                                        inputProps={{
                                                            onChange : event => this.change(event, "accountPlatform"),
                                                            id       : "accountPlatform"
                                                        }}>
                                                        {Object
                                                            .keys(platforms)
                                                            .map((e) => (
                                                                <MenuItem
                                                                    key={e}
                                                                    classes={{
                                                                        root : classes.selectMenuItem
                                                                    }}
                                                                    value={platforms[e].value}>
                                                                    {platforms[e].label}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>

                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                >
                                                    <InputLabel htmlFor="accountType" className={classes.selectLabel}>
                                                        Select Trading Account Types
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.form.accountType  || 'ANY'}
                                                        MenuProps={{
                                                            className : classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select : classes.select
                                                        }}
                                                        inputProps={{
                                                            onChange : event => this.change(event, "accountType"),
                                                            id       : "accountType"
                                                        }}>
                                                        {Object
                                                            .keys(tradingAccountTypes)
                                                            .map((e) => (
                                                                <MenuItem
                                                                    key={e}
                                                                    classes={{
                                                                        root : classes.selectMenuItem
                                                                    }}
                                                                    value={tradingAccountTypes[e].value}>
                                                                    {tradingAccountTypes[e].label}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>

                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                >
                                                    <InputLabel htmlFor="accountLeverage" className={classes.selectLabel}>
                                                        Select Leverages
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.form.accountLeverage  || 'ANY'}
                                                        MenuProps={{
                                                            className : classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select : classes.select
                                                        }}
                                                        inputProps={{
                                                            onChange : event => this.change(event, "accountLeverage"),
                                                            id       : "accountLeverage"
                                                        }}>
                                                        {Object
                                                            .keys(leverages)
                                                            .map((e) => (
                                                                <MenuItem
                                                                    key={e}
                                                                    classes={{
                                                                        root : classes.selectMenuItem
                                                                    }}
                                                                    value={leverages[e].value}>
                                                                    {leverages[e].label}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>

                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={10} md={10} lg={10}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                >
                                                    <InputLabel htmlFor="accountCurrency" className={classes.selectLabel}>
                                                        Select Account Currencies
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.form.accountCurrency  || 'ANY'}
                                                        MenuProps={{
                                                            className : classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select : classes.select
                                                        }}
                                                        inputProps={{
                                                            onChange : event => this.change(event, "accountCurrency"),
                                                            id       : "accountCurrency"
                                                        }}>
                                                        {Object
                                                            .keys(accountCurrencies)
                                                            .map((e) => (
                                                                <MenuItem
                                                                    key={e}
                                                                    classes={{
                                                                        root : classes.selectMenuItem
                                                                    }}
                                                                    value={accountCurrencies[e].value}>
                                                                       {accountCurrencies[e].label}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>

                                                </FormControl>
                                            </GridItem>
                                            {/* Select mrPerType  */}

                                        </GridContainer>
                                        <GridContainer justify="center">
                                            <GridItem xs={12} sm={12} md={12} lg={10}>
                                                <Button type="submit" className={classes.submit} color="rose">Submit</Button>
                                            </GridItem>
                                        </GridContainer>
                                    </form>
                            }
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state, props) => ({
    ibs            : state.ibs,
    ibAccountRules : state.ibAccountRules,
    profiles       : state.profiles,
})

const mapDispatchToProps = (dispatch) => ({

    profilesFetchAll        : (profileName, loading) => dispatch(profilesFetchAllFilter(profileName, loading)),
    profilesFetchIbs        : (profileId, loading) => dispatch(profilesFetchIbs(profileId, loading)),
    ibsFetchFilter          : (ibName) => dispatch(ibsFetchFilter(ibName)),
    ibFilter                : (filter) => dispatch(ibFilter(filter)),
    save                    : (data) => dispatch(ibAccountRuleSave(data)),
    edit                    : (data) => dispatch(ibAccountRuleEditSave(data)),
    danger                  : (text, sec) => dispatch(danger(text, sec)),
    success                 : (text, sec) => dispatch(success(text, sec)),
    //ibsFetchAll: (ibName) => dispatch(ibsFetchAll(ibName)),
    filter                  : (filter) => dispatch(ibFilter(filter)),
    fetch                   : (id) => dispatch(ibAccountRuleFetch(id)),
    setIbAccountRuleProfile : (data) => dispatch(setIbAccountRuleProfile(data)),
    setIbAccountRuleIb      : (data) => dispatch(setIbAccountRuleIb(data)),

})
export default withStyles({...styles, ...selectStyles})(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/IbAccountRules/Form.jsx